/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundDepositRequestDto
 */
export interface FundDepositRequestDto {
  /**
   *
   * @type {string}
   * @memberof FundDepositRequestDto
   */
  depositTypeId: string;
  /**
   *
   * @type {number}
   * @memberof FundDepositRequestDto
   */
  amount: number;
}

export function FundDepositRequestDtoFromJSON(json: any): FundDepositRequestDto {
  return FundDepositRequestDtoFromJSONTyped(json, false);
}

export function FundDepositRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundDepositRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    depositTypeId: json["depositTypeId"],
    amount: json["amount"],
  };
}

export function FundDepositRequestDtoToJSON(value?: FundDepositRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    depositTypeId: value.depositTypeId,
    amount: value.amount,
  };
}
